import { render } from "./CardEventBody.vue?vue&type=template&id=2b210b2c"
import script from "./CardEventBody.vue?vue&type=script&lang=js"
export * from "./CardEventBody.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__